export var mapVerticalSpace={xs:"2xs",s:"2xs",m:"xs",l:"xs"};
//# sourceMappingURL=mapVerticalSpace.js.map